import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SweetAlert from 'sweetalert-react';
import { clearErrors } from '../actions';

class OnlyPrepayError extends Component {
  closeModal = () => {
    this.props.clearErrors();
  };

  confirm = () => {
    this.closeModal();
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  };

  render() {
    return (
      <SweetAlert
        show={this.props.hasError}
        title="Error"
        text={this.props.errorMessage}
        type="error"
        confirmButtonColor="#009d92"
        confirmButtonText="Book and Pay"
        showCancelButton
        cancelButtonText="Cancel"
        onEscapeKey={this.closeModal}
        onConfirm={this.confirm}
        onCancel={this.closeModal}
      />
    );
  }
}

OnlyPrepayError.propTypes = {
  errorMessage: PropTypes.string,
  clearErrors: PropTypes.func.isRequired,
  hasError: PropTypes.bool,
  onConfirm: PropTypes.func, // eslint-disable-line react/require-default-props
};

OnlyPrepayError.defaultProps = {
  errorMessage: '',
  hasError: false,
};

const mapStateToProps = state => ({
  errorMessage: state.reservation.get('errorMessage'),
  hasError: !!state.reservation.get('errorMessage'),
});

const mapDispatchToProps = dispatch => ({
  clearErrors: () => dispatch(clearErrors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OnlyPrepayError);



// WEBPACK FOOTER //
// ./src/app/components/OnlyPrepayError.jsx